export default "__VITE_ASSET__CrHrhy2z__"